export const PENDING_INVITE_REDIRECT_KEY = 'mykol_pending_invite_redirect';

export function sanitizeAppRedirect(raw: string | null | undefined, fallback = ''): string {
  const value = String(raw || '').trim();
  if (!value || !value.startsWith('/') || value.startsWith('//')) return fallback;
  if (/^\/(?:login|register)(?:$|[/?#])/.test(value)) return fallback;
  return value;
}

export function rememberInviteRedirect(path: string): void {
  const safe = sanitizeAppRedirect(path);
  if (safe && safe.startsWith('/invite/')) {
    localStorage.setItem(PENDING_INVITE_REDIRECT_KEY, safe);
  }
}

export function consumeInviteRedirect(): string {
  const value = sanitizeAppRedirect(localStorage.getItem(PENDING_INVITE_REDIRECT_KEY));
  if (value) {
    localStorage.removeItem(PENDING_INVITE_REDIRECT_KEY);
  }
  return value;
}
